import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class UsuarioService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public postUsuario(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_USUARIO;
    return this.http.post<any>(url, params).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Usuario",
            text: "Verifique la informacion ingresada.",
            icon: "error",
            confirmButtonColor: "#127570",
          });
        }

        return throwError(err);
      })
    );
  }

  public putUsuario(usuario): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_USUARIO;
    return this.http.put<any>(url, usuario).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Usuario",
            text: "Error actualizando información del usuario.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public deleteUsuario(usuario): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_USUARIO + "/" + usuario;
    return this.http.delete<any>(url).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Usuario",
            text: "Error eliminado información del usuario.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public getUsuariosPersonas(
    tipoUsuario,
    idUsuario,
    agencia,
    esDistribuidora
  ): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_USUARIO +
      "/" +
      tipoUsuario +
      "/" +
      idUsuario +
      "/" +
      agencia +
      "/" +
      esDistribuidora;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Usuario",
            text: "Error Cargando Usuarios.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public getUsuariosTransportador(tipoUsuario, idUsuario): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_USUARIO +
      "/" +
      tipoUsuario +
      "/" +
      idUsuario;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Transportador",
            text: "Error Cargando Transportador.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public getGestionVendedor(
    idUsuario,
    agencia,
    fechaInicial,
    fechaFinal,
    idUsuarioConsulta
  ): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_USUARIO +
      "/" +
      idUsuario +
      "/" +
      agencia +
      "/" +
      fechaInicial +
      "/" +
      fechaFinal +
      "/" +
      idUsuarioConsulta;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Usuario",
            text: "Error Cargando Usuarios.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }
}
